import { blue, green, grey, orange, red } from "@material-ui/core/colors";
import {
  Currency,
  dateFormatToReadableString,
  ExhibitorPairStatus,
  ExhibitorUserConnectionStatus,
  IShow,
  ShowDateFormat,
  ShowUnitSystem,
} from "@evennt-tech/api-v2-core";

export const attachmentFileExtensions = [
  "doc",
  "docx",
  "pdf",
  "jpg",
  "png",
  "gif",
  "eps",
  "ai",
  "svg",
  "xls",
  "xlsx",
  "csv",
  "ppt",
  "pptx",
];
export const attachmentFileFormats = attachmentFileExtensions
  .map((extension) => `.${extension}`)
  .join(",");
export const fileColors = {
  pdf: red[500],
  docx: blue.A400,
  doc: blue.A400,
  jpg: orange.A400,
  jpeg: orange.A400,
  png: orange.A400,
  gif: orange.A400,
  eps: orange.A400,
  bmp: orange.A400,
  mov: blue["900"],
  mp3: blue["900"],
  mp4: blue["900"],
};
export const imageExtensions = [
  "png",
  "jpg",
  "jpeg",
  "gif",
  "eps",
  "ai",
  "svg",
];
export const excelExtensions = ["xls", "xlsx"];
export const mediaExtensions = ["mov", "mp3", "mp4"];

export const richTextColorPalette = [
  "#000",
  "#e60000",
  "#ff9900",
  "#ffff00",
  "#008a00",
  "#0066cc",
  "#9933ff",
  "#fff",
  "#facccc",
  "#ffebcc",
  "#ffffcc",
  "#cce8cc",
  "#cce0f5",
  "#ebd6ff",
  "#bbbbbb",
  "#f06666",
  "#ffc266",
  "#ffff66",
  "#66b966",
  "#66a3e0",
  "#c285ff",
  "#888888",
  "#a10000",
  "#b26b00",
  "#b2b200",
  "#006100",
  "#0047b2",
  "#6b24b2",
  "#444444",
  "#5c0000",
  "#663d00",
  "#666600",
  "#003700",
  "#002966",
  "#3d1466",
];

export const statusLabels: Record<ExhibitorUserConnectionStatus, string> = {
  [ExhibitorUserConnectionStatus.NOT_INVITED]: "Not invited",
  [ExhibitorUserConnectionStatus.PENDING]: "Pending",
  [ExhibitorUserConnectionStatus.ACTIVE]: "Active",
  [ExhibitorUserConnectionStatus.BLOCKED]: "Blocked",
};

export const pairStatusLabel: Record<ExhibitorPairStatus, string> = {
  [ExhibitorPairStatus.ARCHIVED]: "Archived",
  [ExhibitorPairStatus.ACTIVE]: "Active",
};

export const statusColors: Record<ExhibitorUserConnectionStatus, string> = {
  [ExhibitorUserConnectionStatus.NOT_INVITED]: grey[900],
  [ExhibitorUserConnectionStatus.PENDING]: grey[900],
  [ExhibitorUserConnectionStatus.ACTIVE]: green[500],
  [ExhibitorUserConnectionStatus.BLOCKED]: red[500],
};

export const pairStatusColor: Record<ExhibitorPairStatus, string> = {
  [ExhibitorPairStatus.ARCHIVED]: grey[500],
  [ExhibitorPairStatus.ACTIVE]: green[500],
};

export const currencyLabels: Record<Currency, string> = {
  [Currency.gbp]: "GBP (£)",
  [Currency.aed]: "AED",
  [Currency.eur]: "EUR (€)",
  [Currency.aud]: "AUD (A$)",
  [Currency.usd]: "USD ($)",
};
export const currencySymbols: Record<Currency, string> = {
  [Currency.gbp]: "£",
  [Currency.aed]: "AED",
  [Currency.eur]: "€",
  [Currency.aud]: "A$",
  [Currency.usd]: "$",
};

export const currencies = [
  {
    value: Currency.gbp,
    label: currencyLabels.gbp,
  },
  {
    value: Currency.eur,
    label: currencyLabels.eur,
  },
  {
    value: Currency.aed,
    label: currencyLabels.aed,
  },
  {
    value: Currency.aud,
    label: currencyLabels.aud,
  },
  {
    value: Currency.usd,
    label: currencyLabels.usd,
  },
];

export const getShowDateFormat = (show?: Pick<IShow, "dateFormat"> | null) =>
  show?.dateFormat || ShowDateFormat.dayFirst;
export const getReadableString = (
  show?: Partial<Pick<IShow, "dateFormat">> | null
) =>
  show?.dateFormat ? dateFormatToReadableString[show.dateFormat] : "d MMM yyyy";

export const currenciesAreNotMaintainBankTransfer = [
  Currency.aed,
  Currency.aud,
];
export const unitSystemLabels: { [k in ShowUnitSystem]: string } = {
  metric: "Metric",
  imperial: "Imperial",
};

export const unitSystems: Array<{
  value: ShowUnitSystem;
  label: string;
  units: string;
}> = [
  {
    value: ShowUnitSystem.METRIC,
    units: "m",
    label: unitSystemLabels.metric,
  },
  {
    value: ShowUnitSystem.IMPERIAL,
    units: "ft",
    label: unitSystemLabels.imperial,
  },
];
